import { formatEvaluateDate } from './timeline'

// 自述反馈状态文字颜色映射
const selfReportStatusColorMap = {
  TAKING: '#FC8801',
  INEFFECTIVE: '#999999',
  PARTIAL_EFFECTIVE: '#02C5A2',
  EFFECTIVE: '#02C5A2'
}

// 自述反馈状态背景颜色映射
const selfReportStatusBackgroundMap = {
  TAKING: 'rgba(252, 136, 1, 0.1)',
  INEFFECTIVE: 'rgba(153, 153, 153, 0.1)',
  PARTIAL_EFFECTIVE: 'rgba(2, 197, 162, 0.1)',
  EFFECTIVE: 'rgba(2, 197, 162, 0.1)'
}

/**
 * 患者自述反馈 -> 视图模型
 */
export const createSelfReportFeedbacks = list => {
  if (!Array.isArray(list)) {
    return []
  }
  const length = list.length
  return list.map((item, index) => {
    const seq = length - index
    return {
      ...item,
      title: `第${seq}次自述反馈`,
      feedbackDate: formatEvaluateDate(item.feedbackDate)
    }
  })
}

export const getSelfReportStatusColor = status => selfReportStatusColorMap[status] || '#999999'

export const getSelfReportStatusBackgroundColor = status =>
  selfReportStatusBackgroundMap[status] || 'rgba(153, 153, 153, 0.1)'
